// extracted by mini-css-extract-plugin
export default {"container":"registration_container__D79Nr login_container__+ruY2","form":"registration_form__5Ogqb login_form__cBnz2"};